export default __webpack_public_path__ + "static/media/image.revokex-technology-pvt-ltd-.768a810d.png";